import { AxiosError, AxiosResponse } from "axios";
import { NavigateFunction } from "react-router-dom";
import { createApi } from "../../../utils/createApi";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { VlmConfigResponse } from "./vlmConfigTypes";

export const getCameraVlmConfig = (
  cameraId: string | number,
  navigate: NavigateFunction
): Promise<VlmConfigResponse | null> => {
  const AxiosUI = createApi("");

  const retryFunction = () => getCameraVlmConfig(cameraId, navigate);

  return AxiosUI.get(`/camera/${cameraId}/vlm_config/`)
    .then((response: AxiosResponse<VlmConfigResponse>) => response.data)
    .catch((reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      return null;
    });
};
